import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {BrowserModule} from '@angular/platform-browser';
import {SharedComponentsModule} from '../../../bonding_shared/components/shared-components.module';
import {CompanySharedModule} from '../../company/components/shared/company-shared.module';
import {PolicyContractSharedModule} from '../../policy/components/shared/policy-contract-shared.module';
import {TabViewModule} from 'primeng/tabview';
import {InquiryProductCredendoComponent} from './inquiry-product-credendo.component';
import {InquirySharedModule} from '../shared/inquiry-shared.module';
import {InquiryOffersComponent} from './inquiry-offers.component';
import {InquiryOffersVotingComponent} from './inquiry-offers-voting.component';
import {BondSharedModule} from '../../bond/components/shared/bond-shared.module';
import {BsDropdownModule} from 'ngx-bootstrap/dropdown';
import {InquiryProductCredendoSingleRiskComponent} from './inquiry-product-credendo-single-risk.component';
import {CompanyExtendedSelectorModule} from '../../company/components/shared/extended-selectors/company-extended-selector.module';
import {PolicyModule} from '../../policy/policy.module';
import {DebtorBuyerUltimateUserInquirySectionComponent} from './sections/debtor-buyer-ultimate-user-inquiry-section.component';
import {TransactionPartiesInquirySectionComponent} from './sections/transaction-parties-inquiry-section.component';
import {ExportersInquirySectionComponent} from './sections/exporters-inquiry-section.component';
import {GuarantorsInquirySectionComponent} from './sections/guarantors-inquiry-section.component';
import {InquiryCoInsurersSectionComponent} from './sections/inquiry-co-insurers-section.component';
import {InquiryPrimeDebtorsSectionComponent} from './sections/inquiry-prime-debtors-section.component';

@NgModule({
  imports: [
    RouterModule,
    BrowserModule,
    BsDropdownModule,
    FormsModule,
    ReactiveFormsModule,
    SharedComponentsModule,
    CompanySharedModule,
    PolicyContractSharedModule,
    TabViewModule,
    InquirySharedModule,
    BondSharedModule,
    CompanyExtendedSelectorModule,
    PolicyModule,
  ],
  declarations: [
    InquiryProductCredendoComponent,
    InquiryProductCredendoSingleRiskComponent,
    InquiryOffersComponent,
    InquiryOffersVotingComponent,
    DebtorBuyerUltimateUserInquirySectionComponent,
    TransactionPartiesInquirySectionComponent,
    ExportersInquirySectionComponent,
    GuarantorsInquirySectionComponent,
    InquiryCoInsurersSectionComponent,
    InquiryPrimeDebtorsSectionComponent,
  ],
  exports: [InquiryProductCredendoComponent, InquiryProductCredendoSingleRiskComponent],
})
export class InquiryFormsModule {}
